import React from "react";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem } from "../../../../types";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { useMemberPrivateFileQuery } from "../../../../../../query/files/queries";

const SharedFileName: React.FC<{ fileId: string }> = ({ fileId }) => {
  const queryFile = useMemberPrivateFileQuery(fileId);

  if (queryFile.isLoading) {
    return <></>;
  }

  if (queryFile.isError) {
    return <>File not uploaded</>;
  }

  if (queryFile.data) {
    return <>{queryFile.data.filename}</>;
  }

  return null;
};

export const renderSharedFileName = (
  requirement: IRequirementResponse,
  context: ContextItem,
  sharedFile: ISharedFileRequestResponse | undefined
): React.ReactNode => {
  if (requirement.name) {
    if (sharedFile?.contextType === "Resume") {
      return "Resume summary";
    }
    return requirement.name;
  }

  if (!sharedFile?.fileId) {
    return "File not uploaded";
  }

  return <SharedFileName fileId={sharedFile?.fileId} />;
};
